import './toggle-button.module.scss';
import { ReactNode } from 'react';
import MaterialToggleButton from '@mui/material/ToggleButton';

/* eslint-disable-next-line */
export interface ToggleButtonProps {
  value: any,
  children: any,
  // classes?: object,
  color?: 'primary' | 'secondary' | 'success' | 'error' | 'info' | 'warning',
  disabled?: boolean,
  // disableFocusRipple?: boolean,
  // disableRipple?: boolean,
  fullWidth?: boolean,
  selected?: boolean,
  size?: 'small' | 'medium' | 'large',
  sx?: any,
  onChange?: (event: any) => void,
  className?: string,
  rounded?: boolean
}

export function ToggleButton(props: ToggleButtonProps) {
  let customSx: any = props.rounded ? { borderRadius: '19px', textTransform: 'none' } : { textTransform: 'none' };

  return (
    <MaterialToggleButton
      sx={customSx}
      className={`${props.className}`}
      value={props.value}
      selected={props.selected}
      size={props.size}
      color={props.color}
      onChange={props.onChange}
      disabled={props.disabled}
      fullWidth={props.fullWidth}>
      {props.children}
    </MaterialToggleButton>
  );
}

export function TogglePrimaryButton(props: ToggleButtonProps) {
  return (
    <ToggleButton {...props}
      className={props.className}
      color="primary"
    />
  );
}

export function ToggleSecondaryButton(props: ToggleButtonProps) {
  return (
    <ToggleButton {...props}
      className={props.className}
      color="secondary"
    />
  );
}

export default ToggleButton;